/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Identifiers_DescriptionInputs */

const en_case_section_identifiers_description = /** @type {(inputs: Case_Section_Identifiers_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Common to every case. The internal case number is auto-assigned.`)
};

const pt_br2_case_section_identifiers_description = /** @type {(inputs: Case_Section_Identifiers_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comum a todo caso. O número interno é gerado automaticamente.`)
};

/**
* | output |
* | --- |
* | "Common to every case. The internal case number is auto-assigned." |
*
* @param {Case_Section_Identifiers_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_identifiers_description = /** @type {((inputs?: Case_Section_Identifiers_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Identifiers_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_identifiers_description(inputs)
	return pt_br2_case_section_identifiers_description(inputs)
});